// src/data/vocabularies/index.js

import M1_base from './M1_vocabulary';

const buildBidirectional = (base) => {
  const result = { ...base };
  Object.entries(base).forEach(([enKey, value]) => {
    const esKey = value.translation.split('/')[0].trim().toLowerCase();
    if (!result[esKey]) {
      result[esKey] = { translation: enKey };
    }
  });
  return result;
};

export const vocabularies = {
  M1: buildBidirectional(M1_base),
};

export const getVocabulary = (moduleId) => {
  console.log('📦 getVocabulary llamado con:', moduleId, '→ disponibles:', Object.keys(vocabularies));
  return vocabularies[moduleId] || {};
};
